import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, FormControlLabel, FormGroup } from "@mui/material";
import { useEffect, useState } from "react";
import { track, useContent } from "../../logic";
import { useLocation, useParams } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import { useOrganization } from '../../components/OrganizationProvider';
import { useGetOrder } from "../../logic/useApiQuery";
import { useUpdateSmsPreferenceStatus } from "../../logic/useApiMutation";
import { useOptimisticUpdatePortalOrder } from "../../logic/optimisticUpdates";

export function SmsPreferenceStatusDialog({ open, setOpen }: {
  open: boolean;
  setOpen: Function;
}) {
  const { closingId } = useParams()
  const { search } = useLocation()
  const { data: globalOrderData } = useGetOrder(closingId ?? '', search ?? '')
  const { ClosingsText } = useContent()
  const { CompanyDisplayName } = useOrganization()

  const [consentState, setConsentState] = useState({
    phoneNumber: globalOrderData?.Order.SmsPreferenceStatus?.phoneNumber || '',
    consent: globalOrderData?.Order.SmsPreferenceStatus?.consent ?? true
  });

  const { optimisticUpdatePortalOrder } = useOptimisticUpdatePortalOrder()

  //This is a little weird.  We are not updating on the return data, but instead using what the user set
  const { isLoading: loading, error, mutate } = useUpdateSmsPreferenceStatus(search, {
    onSuccess: () => {
      optimisticUpdatePortalOrder({
        orderKey: closingId ?? '',
        search,
        patch: {
          SmsPreferenceStatus: {
            consent: consentState.consent,
            phoneNumber: consentState.phoneNumber,
          }
        }
      });
    }
  })

  useEffect(() => {
    if (error) {
      track('error', 'useUpdateSmsPreferenceStatus', {}, {
        message: 'error saving sms prefs',
        component: 'SmsPreferenceStatusDialog',
        error: JSON.stringify(error),
      })
    }
  }, [error])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setConsentState((prev => {
      return {
        ...prev,
        consent: event.target.checked,
      }
    }));
  };

  const handleSave = () => {
    mutate({phoneNumber: globalOrderData?.Order.SmsPreferenceStatus?.phoneNumber || '', consent: globalOrderData?.Order.SmsPreferenceStatus?.consent ?? true, orderKey: closingId || ''})
    setOpen(false)
  };

  return (
    <Dialog
      key="userCancel"
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogContent>
        <DialogContentText sx={{ mb: 1 }} variant='h6'>
          SMS Settings
        </DialogContentText>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox checked={consentState.consent} onChange={handleChange} />
            }
            label={`I consent to receive SMS notifications & alerts about my ${ClosingsText} from ${CompanyDisplayName} at ${consentState.phoneNumber}.`}
          />
        </FormGroup>
      </DialogContent>

      <DialogActions>
        <Button variant="rounded" onClick={() => setOpen(false)}>Cancel</Button>
        <LoadingButton loading={loading} variant="contained" onClick={handleSave}>Save</LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
